import { useMemo } from "react";
import { findRenewedIds, isLost } from "../lib/renewal";

export function DashboardAlertStrip({ policies, followUps, vehicles = [], onOpenRenewals, onOpenPolicies, onOpenVehicles }) {
  const stats = useMemo(() => {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const todayStr = today.toISOString().slice(0, 10);
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const weekEnd = new Date(today); weekEnd.setDate(weekEnd.getDate() + 7);
    const thirtyEnd = new Date(today); thirtyEnd.setDate(thirtyEnd.getDate() + 30);
    const renewed = findRenewedIds(policies);
    const todayCount = policies.filter((p) => (p.end || "").slice(0, 10) === todayStr && p.status !== "iptal" && !renewed.has(p.id) && !isLost(p)).length;
    const thisMonth = policies.filter((p) => p.start && new Date(p.start) >= monthStart && p.status !== "iptal").length;
    const upcomingWeek = (followUps || []).filter((f) => {
      if (!f.date) return false;
      const d = new Date(f.date);
      return d >= today && d <= weekEnd && (f.status || "").toLocaleLowerCase("tr") !== "tamamlandı";
    }).length;
    const inspectionSoon = (vehicles || []).filter((v) => {
      if (!v.inspectionEnd) return false;
      const d = new Date(v.inspectionEnd);
      return d <= thirtyEnd;
    }).length;
    return { todayCount, upcomingWeek, thisMonth, inspectionSoon };
  }, [policies, followUps, vehicles]);
  if (stats.todayCount + stats.upcomingWeek + stats.thisMonth + stats.inspectionSoon === 0) return null;
  return (
    <section className="alert-strip" data-testid="dashboard-alert-strip">
      <button type="button" className={`alert-chip red ${stats.todayCount === 0 ? "muted-chip" : ""}`} data-testid="alert-today-renewals" onClick={onOpenRenewals} disabled={stats.todayCount === 0}>
        <span className="alert-dot" />
        <strong>{stats.todayCount}</strong>
        <span>bugün yenilenecek</span>
      </button>
      <button type="button" className={`alert-chip amber ${stats.upcomingWeek === 0 ? "muted-chip" : ""}`} data-testid="alert-week-followups" onClick={onOpenRenewals} disabled={stats.upcomingWeek === 0}>
        <span className="alert-dot" />
        <strong>{stats.upcomingWeek}</strong>
        <span>bu hafta aranacak</span>
      </button>
      <button type="button" className={`alert-chip amber ${stats.inspectionSoon === 0 ? "muted-chip" : ""}`} data-testid="alert-inspection-soon" onClick={onOpenRenewals} disabled={stats.inspectionSoon === 0}>
        <span className="alert-dot" />
        <strong>{stats.inspectionSoon}</strong>
        <span>muayenesi yaklaşan araç</span>
      </button>
      <button type="button" className={`alert-chip green ${stats.thisMonth === 0 ? "muted-chip" : ""}`} data-testid="alert-month-new" onClick={onOpenPolicies} disabled={stats.thisMonth === 0}>
        <span className="alert-dot" />
        <strong>{stats.thisMonth}</strong>
        <span>bu ay yeni poliçe</span>
      </button>
    </section>
  );
}
